import React from 'react';
import { getScheduledNewsletters } from '../../data/serviceCrm';

class ScheduledNewsletters extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
			schedule: [],
		}
	}
    componentDidMount() {
        getScheduledNewsletters().then(response => {
            if (response.emailCount > 0) {
                let list = [];
                for (const [key, value] of Object.entries(response.newsletters)) {
                    list.push(value);
                }
                //console.log(list);
                this.setState({schedule: list});
            }
        });
    }

    render() {
        const { schedule } = this.state;
        //console.log(schedule);
        return(
           <div>
			    <section className="section">
                    <h3>Scheduled Newsletters</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Template Name</th>
                                <th>Total Emails To Send</th>
                                <th>Next Send Date/Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {schedule.map((template, index) => 
                                <tr key={index}>
                                    <td>{template.name}</td>
                                    <td>{template.emails.length}</td>
                                    <td>{template.emails[0].schedule}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    
                </section>
           </div>
        )
    }
}
export default ScheduledNewsletters;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/CrmScheduled.js